// mathNode.js

import { BaseNode } from './BaseNode';
import { Position } from 'reactflow';

export const MathNode = ({ id, data }) => {
  const handles = [
    {
      type: 'target',
      position: Position.Left,
      id: `${id}-a`,
      style: { top: '25%', left: '-2px' }
    },
    {
      type: 'target',
      position: Position.Left,
      id: `${id}-b`,
      style: { top: '75%', left: '-2px' }
    },
    {
      type: 'source',
      position: Position.Right,
      id: `${id}-result`,
      style: { right: '-2px' }
    }
  ];

  const fields = [
    {
      name: 'operation',
      label: 'Operation',
      type: 'select',
      defaultValue: data?.operation || 'add',
      options: [
        { value: 'add', label: '+' },
        { value: 'subtract', label: '-' },
        { value: 'multiply', label: '*' },
        { value: 'divide', label: '/' },
        { value: 'power', label: '^' },
        { value: 'mod', label: '%' }
      ]
    }
  ];

  return (
    <BaseNode
      id={id}
      data={data}
      type="math"
      title="Math"
      handles={handles}
      fields={fields}
    />
  );
};
